"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LINK = void 0;
const vue_1 = __importDefault(require("vue"));
const z = __importStar(require("zod"));
const types_1 = require("./types");
const cell_formatter_1 = require("./cell-formatter");
const LINK_FORMATTER_CONFIG = types_1.BASE_CONFIG.extend({
    to: z.union([z.string(), z.record(z.any())]).optional(),
    target: z
        .string()
        .optional()
        .default('_self')
});
exports.LINK = {
    name: 'link',
    formatter: {
        schema: LINK_FORMATTER_CONFIG,
        createComponent(config) {
            return {
                component: {
                    name: 'LinkFormatter',
                    mixins: [cell_formatter_1.CellFormatter],
                    ...vue_1.default.compile(`<b-link
                v-bind="bindings"
                @click="col.emitCellEvent('click', row)"
              >{{ value }}</b-link>`),
                    data() {
                        return {
                            bindings: {
                                to: config.to,
                                target: config.target
                            }
                        };
                    }
                }
            };
        }
    }
};
//# sourceMappingURL=link.js.map